export default __webpack_public_path__ + "static/media/CST-new-logo.fbfe76f1.svg";